import React from "react";
import {
  Row,
  Col,
  Input,
  message,
  Button,
  Space,
  DatePicker,
  Tooltip,
  Modal,
  Image,
  Drawer,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import CompanyAutocomplete from "./CompanyAutocomplete";
import ListTable from "./ListTable";
import withRouter from "../withRouter";
import CompanyStore from "../store/CompanyStore";
import NewMaintenanceStore from "../store/NewMaintenanceStore";
import NewMaintenanceAdd from "./NewMaintenanceAdd";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import dayjs from "dayjs";

class NewMaintenanceList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.newMaitenanceStore = new NewMaintenanceStore(this);
    this.companyStore = new CompanyStore(this);

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      offset: 0,
      limit: 50,
      companyId: "",
      loadData: 0,
      openConfirm: false,
      confirmLoading: false,
      company_value_label: "",
      searchField: "",
      servicedateFrom: "",
      servicedateTo: "",
      openVehicleMaintenanceForm: false,
      vehicleMaintenanceId: "",
      listDataUpdate: false,
      companyFieldHighlight: false,
      openDeleteModal: false,
      deleteData: {},
    };

    this.columns = [
      {
        // title: " Vehicle No",
        title: context.translate("_VEHICLE_NO_"),
        dataIndex: "vehicleNo",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
        render: (val, record) => {
          return (
            <Link
              style={{ color: "#2563EB", textDecoration: "none" }}
              onClick={(e) => {
                e.preventDefault();
                this.props.canUpdate("newMaintenanceList") &&
                  this.onEdit(record);
              }}
            >
              {val}
            </Link>
          );
        },
      },
      {
        // title: "Driver Name",
        title: context.translate("_DRIVER_NAME_"),
        dataIndex: "name",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Current Odometer ",
        title: context.translate("_CURRENT_ODOMETER_"),
        dataIndex: "currentOdometer",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: " Garage Name",
        title: context.translate("_GARAGE_NAME_"),
        dataIndex: "garageName",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Service Date",
        title: context.translate("_SERVICE_DATE_"),
        dataIndex: "serviceDate",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Service Type ",
        title: context.translate("_SERVICE_TYPE_"),
        dataIndex: "serviceName",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Service Type ",
        title: context.translate("_MAINTENANCE_TYPE_"),
        dataIndex: "maintenanceType",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: " Garage Address ",
        title: context.translate("_GARAGE_ADDRESS_"),
        dataIndex: "garageAddress",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "  Amount ",
        title: context.translate("_AMOUNT_"),
        dataIndex: "totalAmmount",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_ACTION_"),
        dataIndex: "Action",
        key: "Action",
        // fixed: 'right',
        width: 10,
        ellipsis: {
          showTitle: true,
        },
        align: "center",
        render: (_, record) => {
          return (
            <>
              <Space>
                <Tooltip title="Edit" placement="bottom">
                  {this.props.canUpdate("newMaintenanceList") && (
                    <Image
                      style={{
                        height: "15px",
                        width: "15px",
                        borderRadius: "0px",
                        cursor: "pointer",
                      }}
                      src={editIcon}
                      onClick={async (e) => {
                        e.preventDefault();
                        await this.onEdit(record);
                      }}
                    ></Image>
                  )}
                </Tooltip>

                {this.props.canDelete("newMaintenanceList") && (
                  <Tooltip
                    title={context.translate("_DELETE_MAINTENANCE_")}
                    placement="bottom"
                  >
                    <Image
                      src={require("../assets/images/NewDesign/Delete.png")}
                      style={{ cursor: "pointer", width: "15px" }}
                      onClick={() =>
                        this.setState({
                          openDeleteModal: true,
                          deleteData: record,
                        })
                      }
                    ></Image>
                  </Tooltip>
                )}

                {/* <DeleteConfirm
                  onConfirm={(e) => {
                    e.preventDefault();
                    this.onDelete(record);
                  }}
                >
                  <Link>
                    <Tooltip
                      // title="Delete Maintenance"
                      title={context.translate("_DELETE_MAINTENANCE_")}
                      placement="bottom"
                      color={config.tooltipColorDelete}
                    >
                      <DeleteFilled style={{ color: config.deleteColor }} />
                    </Tooltip>
                  </Link>
                </DeleteConfirm> */}
              </Space>
            </>
          );
        },
      },
    ];
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      const beforeEditCompanyId =
        this.context.viewStateStore.newMaintenanceObject.companyId;
      await this.newMaitenanceStore.loadData({
        offset: (this.state.currentPage - 1) * this.state.pageSize,
        limit: this.state.pageSize,
        companyId: beforeEditCompanyId,
        searchField: this.state.searchField,
        isadmin: this.props.getUserData().isadmin,
        userId: this.props.getUserData().userId,
      });
      const singleData = await this.companyStore.getCompanyDataById(
        this.context.viewStateStore.newMaintenanceObject.companyId
      );
      await this.setState({ listUpdated: 1 }); //need to reload data
      await this.setState({
        company_value_label: singleData,
        companyId: beforeEditCompanyId,
      });
      this.setState({ listDataUpdate: false });
    }
  }

  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ userId: this.props.getUserData().userId });
      await this.handleSearch();
    }

    this.setState({ pageSize: 50 });
  }

  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  async handleChange(comp) {
    await this.setState({
      companyId: comp.value,
      currentPage: 1,
      pageSize: 50,
    });
    const singleData = await this.companyStore.getCompanyDataById(comp.value);
    await this.setState({ company_value_label: singleData });
    await this.handleSearch();
  }

  async handleSearch() {
    // console.log(this.props.getUserData())
    this.setState({ loading: true });
    await this.newMaitenanceStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      searchField: this.state.searchField,
      companyId: this.state.companyId,
      isadmin: this.props.getUserData().isadmin,
      userId: this.props.getUserData().userId,
      servicedateFrom: this.state.servicedateFrom,
      servicedateTo: this.state.servicedateTo,
    });
    await this.setState({ loadData: 1 });
  }

  onEdit = async (record) => {
    await this.context.viewStateStore.setNewVehMaintenanceStates({
      companyId: record.companyId,
    });
    this.setState({ vehicleMaintenanceId: record.Id });
    this.setState({ openVehicleMaintenanceForm: true });
    // await this.props.navigate("/vehiclemaintenanceadd/" + record.Id);
  };

  async onDelete(record) {
    const response = await this.newMaitenanceStore.deleteRecord({
      Id: record.Id,
    });
    //  console.log(response.data.success)
    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }

  searchInput = async (e) => {
    const value = e.target.value;
    if (value.length > 2 || value.length === 0) {
      await this.newMaitenanceStore.loadData({
        offset: (this.state.currentPage - 1) * this.state.pageSize,
        limit: this.state.pageSize,
        servicedateFrom: this.state.servicedateFrom,
        servicedateTo: this.state.servicedateTo,
        isadmin: this.props.getUserData().isadmin,
        userId: this.props.getUserData().userId,
        searchField: value,
        companyId: this.state.companyId,
      });
      await this.setState({ loadList: 0 });
    }
  };

  async searchInputButton() {
    if (!this.state.companyId) {
      this.setState({ companyFieldHighlight: true });
    } else {
      this.setState({ companyFieldHighlight: false });
    }
    if (this.state.companyId) {
      this.setState({ companyFieldHighlight: false, loading: true });
      await this.newMaitenanceStore.loadData({
        offset: 0,
        limit: 50,
        searchField: this.state.searchField,
        servicedateFrom: this.state.servicedateFrom,
        servicedateTo: this.state.servicedateTo,
        companyId: this.state.companyId,
        isadmin: this.props.getUserData().isadmin,
        userId: this.props.getUserData().userId,
      });
      await this.setState({ loadData: 1 });
    }
  }

  responseMsg = async (resp) => {
    if (resp.data.success == "S") {
      message.success(resp.data.message);
      this.setState({ openVehicleMaintenanceForm: false });
      this.setState({ listDataUpdate: true });
      //  this.props.navigate("/vehiclemaintenancelist");
    } else if (resp.data.success == "F0") {
      resp.data.errors.map((value) => {
        message.error(["This Service Type already exists"]);
      });
    }
  };

  closeModal = () => {
    this.setState({
      openVehicleMaintenanceForm: false,
      vehicleMaintenanceId: "",
    });
  };

  refreshList = async () => {
    this.setState({ loading: true });
    if (this.state.companyId) {
      await this.newMaitenanceStore.loadData({
        companyId: this.state.companyId,
        offset: 0,
        limit: 50,
        searchField: "",
        servicedateFrom: "",
        servicedateTo: "",
      });
    }
    this.setState({
      loading: false,
      searchField: "",
      servicedateFrom: "",
      servicedateTo: "",
      currentPage: 1,
    });
  };

  render() {
    const companyInputBox = this.state.companyFieldHighlight
      ? { border: "2px solid red", width: "150px", borderRadius: "8px" }
      : { width: "150px" };
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  onChange={(value) => this.handleChange(value)}
                  value={
                    this.state.company_value_label
                      ? this.state.company_value_label
                      : null
                  }
                  style={companyInputBox}
                />
                <Input
                  value={this.state.searchField ? this.state.searchField : ""}
                  placeholder={this.context.translate(
                    "_SEARCH_BY_GARAGE_VEHICLE_"
                  )}
                  style={{ width: 300, borderRadius: "25px" }}
                  onKeyUp={(e) => this.searchInput(e)}
                  onChange={(e) => {
                    this.setState({ searchField: e.target.value });
                  }}
                />

                <DatePicker
                  value={
                    this.state.servicedateFrom
                      ? dayjs(this.state.servicedateFrom)
                      : null
                  }
                  style={{ width: "160px", borderRadius: "25px" }}
                  placeholder={this.context.translate("_FROM_DATE_")}
                  allowClear
                  onChange={async (val) => {
                    if (val === null) {
                      await this.setState({ servicedateFrom: "" });
                      await this.handleSearch();
                    } else {
                      await this.setState({
                        servicedateFrom: val.format("YYYY-MM-DD"),
                      });
                      await this.handleSearch();
                    }
                  }}
                />

                <DatePicker
                  value={
                    this.state.servicedateTo
                      ? dayjs(this.state.servicedateTo)
                      : null
                  }
                  style={{ width: "160px", borderRadius: "25px" }}
                  placeholder={this.context.translate("_TO_DATE_")}
                  allowClear
                  onChange={async (val) => {
                    if (val === null) {
                      await this.setState({ servicedateTo: "" });
                      await this.handleSearch();
                    } else {
                      await this.setState({
                        servicedateTo: val.format("YYYY-MM-DD"),
                      });
                      await this.handleSearch();
                    }
                  }}
                />
                <Button
                  icon={<SearchOutlined />}
                  type="primary"
                  onClick={() => {
                    this.searchInputButton();
                  }}
                />
              </Space>
            </Col>
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={8}
            >
              <Tooltip
                title={this.context.translate("_REFRESH_")}
                placement="bottom"
              >
                <Image
                  style={{
                    height: 18,
                    alignItems: "center",
                    cursor: "pointer",
                    marginInlineEnd: "20px",
                  }}
                  src={refreshIcon}
                  onClick={() => this.refreshList()}
                ></Image>
              </Tooltip>
              {this.props.canCreate("newMaintenanceList") && (
                <Button
                  className="addButtonClass"
                  onClick={() =>
                    this.setState({
                      openVehicleMaintenanceForm: true,
                      vehicleMaintenanceId: "",
                    })
                  }
                >
                  <Image
                    style={{ marginInlineEnd: "5px", width: 13 }}
                    src={require("../assets/images/NewDesign/plus (Stroke).png")}
                  ></Image>
                  {this.context.translate("_FLEET_DRIVER_DRIVERLIST_ADDBTN_")}
                </Button>
              )}
            </Col>
          </Row>

          <ListTable
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.newMaitenanceStore?.total}
            columns={this.columns}
            dataSource={this.newMaitenanceStore?.maintainVehicles}
            loading={this.newMaitenanceStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        {this.state.openVehicleMaintenanceForm && (
          <Drawer
            className="uploadExcelDrawer"
            width={716}
            closeIcon={false}
            open={this.state.openVehicleMaintenanceForm}
            placement={this.context.locale.language === "english" ? "right" : "left"}
            footer={false}
            title={
              <div className="formTitle">
                {this.context.translate("_ADD_MAINTENANCE_DETAILS_")}
                <p className="formDescription">
                  {this.context.translate("_NEW_MAINTENANCE_ADD_DESC_")}
                </p>
              </div>
            }
            maskClosable={false}
            onOk={() => this.setState({ openVehicleMaintenanceForm: false })}
            onCancel={() =>
              this.setState({ openVehicleMaintenanceForm: false, userId: "" })
            }
          >
            <div style={{ height: "100%" }}>
              <NewMaintenanceAdd
                vehicleMaintenanceId={this.state.vehicleMaintenanceId}
                companyId={this.state.companyId}
                response={this.responseMsg}
                closeModal={this.closeModal}
              />
            </div>
          </Drawer>
        )}

        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}
NewMaintenanceList.contextType = StoreContext;
export default observer(withRouter(NewMaintenanceList));
